var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPause18 = function SvgIconPause18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2B328C",
    d: "M3.023 52.977h49.953V3.024H3.023v49.953zM0 56h56V0H0v56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999DC8",
    d: "M22 34h5V21h-5zm7 0h5V21h-5z"
  }))));
};
export default SvgIconPause18;